import moment from 'moment';

import { STATUSES } from '../../constans/statuses-writes';
import { SWITCH_LOADING_SCHEDULE } from './actions';

export const WS_SET_CREATING_WRITE_SCHEDULE = 'WS_SET_CREATING_WRITE_SCHEDULE';
export const WS_UNSET_CREATING_WRITE_SCHEDULE = 'WS_UNSET_CREATING_WRITE_SCHEDULE';
export const WS_CURRENT_EDITING_WRITES_SCHEDULE = 'WS_CURRENT_EDITING_WRITES_SCHEDULE';
export const WS_CREATE_WRITE_SCHEDULE = 'WS_CREATE_WRITE_SCHEDULE';
export const WS_GET_SCHEDULE = 'WS_GET_SCHEDULE';

moment.locale('ru');

export const getScheduleWSAction = (filter, ws) => (dispatch) => {
    const hms = moment();
    let doctorID = null;

    if (filter.doctor && typeof filter.doctor === 'number') {
        doctorID = filter.doctor;
    }
    if (filter.doctor && typeof filter.doctor === 'object') {
        doctorID = +filter.doctor.value;
    }

    const params = {
        currentDate: +filter.date.set({ hour: hms.hours(), minute: hms.minutes(), second: hms.seconds() }).format('x'),
        speciality: filter.speciality && +filter.speciality.value ? [filter.speciality.value] : [],
        filial: filter.filial && +filter.filial.value ? filter.filial.value : null,
        typeView: filter.typeView.value,
        doctors: doctorID || null
    };

    dispatch({ type: SWITCH_LOADING_SCHEDULE });

    ws.ws.send(JSON.stringify({
        type: WS_GET_SCHEDULE,
        params,
        connectionID: ws.userConnectionID
    }));
};

export const setCreatingWriteWSAction = (type, ticket, doctor, user, ws) => {
    switch (type) {
        case 'SET':
            ws.ws.send(JSON.stringify({
                type: WS_SET_CREATING_WRITE_SCHEDULE,
                ticket,
                doctorID: doctor.id,
                user,
                connectionID: ws.userConnectionID
            }));
            break;
        case 'UNSET':
            ws.ws.send(JSON.stringify({
                type: WS_UNSET_CREATING_WRITE_SCHEDULE,
                ticket,
                doctorID: doctor.id,
                user,
                connectionID: ws.userConnectionID
            }));
            break;
        default:
            break;
    }
};

export const createWriteWSAction = (fields, creatingData, ws) => {
    const sendData = {
        status: STATUSES.notConfirmed.value,
        recorded_user_id: 0,
        recorded_from_site: 1,
        doctor_worker_id: +creatingData.doctor.id,
        filial_id: +creatingData.doctor.schedule_filial,
        patient_last_name: fields['last-name'],
        patient_first_name: fields['first-name'],
        patient_second_name: fields['second-name'],
        patient_phone: fields.phone,
        patient_birthday: Object().hasOwnProperty.call(fields, 'birthday') ? +moment(fields.birthday).format('x') : +moment().format('x'),
        patient_type_payment: +fields['payment-type'].value,
        patient_type_reception: 1,
        patient_comment: fields.comments ? fields.comments : '',
        patient_representative: fields.representative ? fields.representative : '',
        date_write: moment(creatingData.ticket.dateTicket).format('YYYY-MM-DD HH:mm:ss'),
        time_start: creatingData.ticket.time[0],
        time_end: creatingData.ticket.time[1],
        isPart: creatingData.ticket.isPart
    };

    ws.ws.send(JSON.stringify({
        type: WS_CREATE_WRITE_SCHEDULE,
        data: sendData,
        connectionID: ws.userConnectionID
    }));
};
